<template>
  <div class="template">
    <AproposDesktop class="template__Desktop" />
    <AproposMobile class="template__Mobile" />

  </div>
</template>

<script>
import AproposDesktop from '@/components/apropos/AproposDesktop.vue'
import AproposMobile from '@/components/apropos/AproposMobile.vue'
export default {
  name: 'AproposView',
  components: {
    AproposDesktop,
    AproposMobile
  }
}
</script>


<style lang=scss>

.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>
